import { ReactNode } from "react"
import { Container } from "reactstrap"
import Breadcrumb from "Components/organisms/breadcrumb"
import KpiCard from "Components/organisms/financial-kpi/kpi-card"
import KpiTable from "Components/organisms/financial-kpi/kpi-table"
import GrossMarginSection from "Components/organisms/financial-kpi/gross-margin-section"
import FunnelSection from "Components/organisms/financial-kpi/funnel-section"
import { FinancialKpiData } from "models/financial-kpi"

interface FinancialKpiTemplateProps {
    fiscalYear: number
    filters: ReactNode
    actions?: ReactNode
    data: FinancialKpiData
    canSaveSnapshot: boolean
    isSavingSnapshot: boolean
    onSaveSnapshot: () => Promise<void>
}

// Finance > Financial KPI Metrics: fiscal year filter, then one card per KPI container in the Excel order.
const FinancialKpiTemplate = ({ fiscalYear, filters, actions, data, canSaveSnapshot, isSavingSnapshot, onSaveSnapshot }: FinancialKpiTemplateProps) => (
    <div className="page-content">
        <Container fluid style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Breadcrumb title="Finance" breadcrumbItem="Financial KPI Metrics" actions={actions} />
            <div className="section-container">{filters}</div>

            <KpiCard title="Total Annual Revenue" subtitle="Consulting income + accrued, closed months" isLoading={!data.revenue}>
                <KpiTable rows={data.revenue ?? []} />
            </KpiCard>

            <KpiCard title="Client Revenue" subtitle="Clients from Admin > Client Mapping" isLoading={!data.clientRevenue}>
                <KpiTable rows={data.clientRevenue ?? []} emptyMessage="No clients yet. Add them in Admin > Client Mapping." />
            </KpiCard>

            <GrossMarginSection data={data.grossMargin} isLoading={!data.grossMargin} />

            <KpiCard title={`WIH Backlog ${fiscalYear + 1}`} subtitle="Project forecast of the next fiscal year, frozen by the monthly snapshot" isLoading={!data.wih}>
                <KpiTable rows={data.wih ?? []} />
            </KpiCard>

            <FunnelSection
                fiscalYear={fiscalYear}
                groups={data.funnel}
                status={data.snapshots}
                isLoading={!data.funnel || !data.snapshots}
                canSave={canSaveSnapshot}
                isSaving={isSavingSnapshot}
                onSave={onSaveSnapshot}
            />

            <KpiCard title="Company KPIs" subtitle="AR overdue, turnover, proposal win rate and billability" isLoading={!data.other}>
                <KpiTable rows={data.other ?? []} />
            </KpiCard>
        </Container>
    </div>
)

export default FinancialKpiTemplate
